/***
 * @ngdoc directive
 * @name BB:bbSkipDecideNextPage
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Disables the auto decide next page inside the widget controllers
 *
 * <pre>
 * restrict: 'AE'
 * replace: true
 * scope: true
 * </pre>
 *
 * @property {string} target widget directive name, e.g. bb-times
 *///


angular.module('BBPublicBooking').directive('bbSkipDecideNextPage', (bbWidgetPage) => {

    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        link: (scope, element, attrs) => {

            if (attrs.bbSkipDecideNextPage)
                bbWidgetPage.setAutoDecideNextPage(attrs.bbSkipDecideNextPage, false);
            else
                console.warn('Warning: you forgot to use the bb-skip-decide-next-page="directive-name" notation');

        }
    };

});



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/skip-decide-next-page/bb_skip_decide_next_page.directive.js